module.exports = __webpack_public_path__ + "static/img/arthroscopy-detail-23.47a2c2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-detail-23.jpg
// module id = LqV6
// module chunks = 51